import { render, staticRenderFns } from "./RequestShow.vue?vue&type=template&id=799c22f2&scoped=true&"
import script from "./RequestShow.vue?vue&type=script&lang=js&"
export * from "./RequestShow.vue?vue&type=script&lang=js&"
import style0 from "./RequestShow.vue?vue&type=style&index=0&id=799c22f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799c22f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('799c22f2')) {
      api.createRecord('799c22f2', component.options)
    } else {
      api.reload('799c22f2', component.options)
    }
    module.hot.accept("./RequestShow.vue?vue&type=template&id=799c22f2&scoped=true&", function () {
      api.rerender('799c22f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/quotation-requests/RequestShow.vue"
export default component.exports